"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeatureBang = exports.FeatureBangProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* istanbul ignore file */

var FeatureBangContext = /*#__PURE__*/(0, _react.createContext)();
var FeatureBangProvider = exports.FeatureBangProvider = function FeatureBangProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  return /*#__PURE__*/_react["default"].createElement(FeatureBangContext.Provider, {
    value: {
      config: config
    }
  }, children);
};
var useFeatureBang = exports.useFeatureBang = function useFeatureBang() {
  var config = (0, _react.useContext)(FeatureBangContext);
  if (!config) {
    throw new Error("Can not use useFeatureBang outside of a FeatureBang Provider");
  }
  return config;
};